import { render, staticRenderFns } from "./expressSettingDialog.vue?vue&type=template&id=5e4db0db&scoped=true&"
import script from "./expressSettingDialog.vue?vue&type=script&lang=js&"
export * from "./expressSettingDialog.vue?vue&type=script&lang=js&"
import style0 from "./expressSettingDialog.vue?vue&type=style&index=0&id=5e4db0db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4db0db",
  null
  
)

export default component.exports